export class Controller {

    /** @ngInject */
    constructor(
        AuthenticationPoliciesService,
        AuthenticationAccessPolicyResource,
        Alert,
        $state,
        ) {
        this.Alert= Alert;
        this.$state= $state;
        this.AuthenticationPoliciesService = AuthenticationPoliciesService;
        this.AuthenticationAccessPolicyResource = AuthenticationAccessPolicyResource;
    }

    $onInit() {
        this.newAuthSettings = angular.copy(this.currentPasswordAuthenticationSettings);
        this.newAuthAccessSettings = angular.copy(this.authenticationAccessPolicyList);
        this.newAdaptiveAuthSettings = angular.copy(this.currentAdaptiveAuthenticationSettings);
        this.selectedPolicy = this.newAuthSettings.passwordPolicyId != null ? this.newAuthSettings.companyPasswordPolicies.find(p => p.passwordPolicyId === this.newAuthSettings.passwordPolicyId) : this.newAuthSettings.companyPasswordPolicies.find(p => p.passwordPolicyName === "Default Policy");
        this.pap = this.selectedPolicy;
        this.aap = this.newAuthAccessSettings.find(p=>p.id===this.application.accessPolicyId);
        if (this.aap) {
            this.selectedAuthAccessPolicy = this.aap;
        } else {
            this.selectedAuthAccessPolicy = this.newAuthAccessSettings.find(p => p.name === "Default Policy");
        }
        if (this.application.applicationType.slug==='google-apps'){
            //this.newAuthSettings.passwordAuthenticationOnGoogle=true;
        }
        this.settings;
    }
    cancel() {
        this.config = {...this.application};
    }

    is(...types) {
        return types.includes(this.application.applicationType.slug);
    }

    // notModified() {
    //     return angular.equals(this.application, this.config);
    // }

    // save() {
    //     this.isSaving = true;
    //
    // }

    saveDisabled(form) {
        return form.$invalid || this.isSaving || this.notModified();
    }


    notModified(){
        let obj1 = this.newAuthSettings.passwordPolicyId != null ? this.newAuthSettings.companyPasswordPolicies.find(p => p.passwordPolicyId === this.newAuthSettings.passwordPolicyId) : this.newAuthSettings.companyPasswordPolicies.find(p => p.passwordPolicyName === "Default Policy")
        return ((obj1!==this.selectedPolicy)) || (angular.equals(this.newAuthSettings,this.currentPasswordAuthenticationSettings))
    }
    save(){
        this.newAuthSettings.passwordPolicyId=this.selectedPolicy.passwordPolicyId;

        if (this.application.applicationType.slug==='google-apps'){
            this.settings={
                "enablePasswordAuthentication": this.newAuthSettings.enablePasswordAuthentication,
                "passwordAuthenticationOnGoogle": this.newAuthSettings.enablePasswordAuthentication===false ? null : this.newAuthSettings.passwordAuthenticationOnGoogle,
                "passwordPolicyId": this.newAuthSettings.passwordAuthenticationOnGoogle === false ? this.selectedPolicy.passwordPolicyId : null,
                "enableOnPremisesAdAuthentication": this.newAuthSettings.enablePasswordAuthentication===false ? false :this.newAuthSettings.enableOnPremisesAdAuthentication,
                "notAssignedAccountLoginSetting": this.newAuthSettings.notAssignedAccountLoginSetting,
                "pendingAssignedAccountLoginSetting": this.newAuthSettings.pendingAssignedAccountLoginSetting,
                "notExistAccountLoginSetting": this.newAuthSettings.notExistAccountLoginSetting,
            }
        }
        else {
            if (this.newAuthSettings.enablePasswordAuthentication === false) {
                this.settings = {
                    "enableOnPremisesAdAuthentication": false,
                    "enablePasswordAuthentication": false,
                    "notAssignedAccountLoginSetting": null,
                    "notExistAccountLoginSetting": null,
                    "passwordAuthenticationOnGoogle": null,
                    "passwordPolicyId": null,
                    "pendingAssignedAccountLoginSetting": null
                }
            }
            else this.settings = this.newAuthSettings;
        }

        this.AuthenticationPoliciesService.UpdateCurrentPasswordAuthenticationSettings(this.companyId,this.application.id,this.settings)
            .then(() => this.Alert('success', 'company.policies.settings_updated'))
            .then(() => this.$state.reload('company.manage-application'))
            .finally(() => this.isSaving = false)
    }
    saveAuthPolicy(){
        this.AuthenticationAccessPolicyResource.applyPolicy(this.companyId, this.selectedAuthAccessPolicy.id, this.application.id)
            .then(()=>{
                this.Alert(
                    'success',
                    'company.policies.settings_updated'
                )
            })
            .then(() => this.$state.reload('company.manage-application'))
    }

    adaptiveAuthNotModified() {
        return angular.equals(this.currentAdaptiveAuthenticationSettings, this.newAdaptiveAuthSettings);
    }

    saveAdaptiveAuthenticationSettings(){
        this.AuthenticationPoliciesService.UpdateCurrentAdaptiveAuthenticationSettings(this.companyId, this.application.id, this.newAdaptiveAuthSettings)
            .then(()=>{
                this.Alert(
                    'success',
                    'company.manage-application.adaptive-authentication-and-anomaly-behavior.updated'
                )
            })
            .then(() => this.$state.reload('company.manage-application'))
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/authentication-policies/authentication-policies.controller.js